<div class="support-wrapper flex flex-col pt-[0] px-[15px] pb-[24px]">
	<div class="support-header pt-[26.5px] pb-[8px]">
		<ng-container>
			<div class="slider-header">
				<div class="upper flex-container align-center gap-[14px]">
					<span><svg  (click)="close()" fill="none" height="19" viewBox="0 0 19 19" width="19"
							xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_17318_127065)">
								<path
									d="M17.8127 8.3129H4.54837L10.3434 2.5179C10.8065 2.05478 10.8065 1.29478 10.3434 0.831652C10.2335 0.721567 10.103 0.634229 9.95936 0.574638C9.81571 0.515048 9.66171 0.484375 9.50618 0.484375C9.35066 0.484375 9.19666 0.515048 9.053 0.574638C8.90935 0.634229 8.77886 0.721567 8.669 0.831652L0.843371 8.65728C0.733286 8.76714 0.645948 8.89763 0.586358 9.04129C0.526767 9.18494 0.496094 9.33894 0.496094 9.49447C0.496094 9.64999 0.526767 9.80399 0.586358 9.94764C0.645948 10.0913 0.733286 10.2218 0.843371 10.3317L8.669 18.1573C8.77894 18.2672 8.90946 18.3544 9.0531 18.4139C9.19674 18.4734 9.3507 18.5041 9.50618 18.5041C9.66166 18.5041 9.81562 18.4734 9.95927 18.4139C10.1029 18.3544 10.2334 18.2672 10.3434 18.1573C10.4533 18.0473 10.5405 17.9168 10.6 17.7732C10.6595 17.6295 10.6901 17.4756 10.6901 17.3201C10.6901 17.1646 10.6595 17.0107 10.6 16.867C10.5405 16.7234 10.4533 16.5928 10.3434 16.4829L4.54837 10.6879H17.8127C18.4659 10.6879 19.0002 10.1535 19.0002 9.5004C19.0002 8.84728 18.4659 8.3129 17.8127 8.3129Z"
									fill="#0361F0" />
							</g>
							<defs>
								<clipPath id="clip0_17318_127065">
									<rect fill="white" height="19" width="19" />
								</clipPath>
							</defs>
						</svg>
					</span>
					<span class="title font-[700] text-[27.2px] leading-[29px] text-[#1A0C2F]">Need Help?</span>
				</div>
				<div class="lower mt-[10px] font-[400] text-base leading-[150%]">
					Select how you want us to help you
				</div>

			</div>
		</ng-container>
	</div>
	<div class="support-body flex-1 overflow-y-auto max-h-[calc(100vh_-_194px)]">
		<div class="support-mobile">
			<div class="chat-section m-t-24">
				<div class="header-section flex-container gap-[10px] align-center">
					<div class="header font-[700] text-[19.2px] leading-[22px]">Chat</div>
					<div class="label font-[700] rounded-[4px] text-[12.8px] py-[4px] px-[8px]">Avg. Response time: 1 min</div>
				</div>

				<div class="content m-t-16">
					<div [nzGutter]="19" nz-row nzJustify="space-between">
						<div nz-col nzSpan="12">
							<div (click)="openChat($event)" class="content-section addCursor pt-[13.63px] pr-[14px] pb-[15px] pl-[14px] rounded-[12px]" id="myLauncher">
								<svg fill="none" height="41" viewBox="0 0 40 41" width="40"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_17284_127160)">
										<circle cx="20" cy="20.6328" fill="#0357EE" fill-opacity="0.1" r="20" />
										<path clip-rule="evenodd"
											d="M29.223 14.5234C30.3741 14.5234 31.3093 15.4587 31.3093 16.6098H31.3333V25.099C31.3333 26.25 30.3981 27.1853 29.247 27.1853H23.5156C23.4916 27.1853 23.4916 27.2093 23.4916 27.2093L20.8057 29.8711C20.542 30.1589 20.0863 29.9671 20.0863 29.5834V27.1853H17.976C16.8249 27.1853 15.8897 26.25 15.8897 25.099V16.6098C15.8897 15.4587 16.8249 14.5234 17.976 14.5234H29.223ZM8.95923 16.0822C8.43165 16.0822 8 16.5138 8 17.0414C8 17.569 8.43165 18.0007 8.95923 18.0007H13.1799C13.7074 18.0007 14.1391 17.569 14.1391 17.0414C14.1391 16.5138 13.7074 16.0822 13.1799 16.0822H8.95923ZM13.1559 21.8136C13.6834 21.8136 14.1151 21.3819 14.1151 20.8544C14.1151 20.3268 13.7074 19.8951 13.1559 19.8951H10.0384C9.51079 19.8951 9.07914 20.3268 9.07914 20.8544C9.07914 21.3819 9.51079 21.8136 10.0384 21.8136H13.1559ZM13.1559 25.6265C13.6834 25.6265 14.1151 25.1949 14.1151 24.6673C14.1151 24.1397 13.7074 23.7081 13.1799 23.7081H11.2614C10.7338 23.7081 10.3022 24.1397 10.3022 24.6673C10.3022 25.1949 10.7338 25.6265 11.2614 25.6265H13.1559Z"
											fill="#0361F0" fill-rule="evenodd" />
									</g>
									<defs>
										<clipPath id="clip0_17284_127160">
											<rect fill="white" height="40" transform="translate(0 0.632812)"
												width="40" />
										</clipPath>
									</defs>
								</svg>
								<div class="bottom-content mt-[16px]">
									<div class="bottom-header font-[700] text-[18px] text-[#0B3275]">Live Web Chat</div>
									<div class="bottom-label font-[600] text-[12px] leading-[15px] mt-[4px] opacity-50">Start a conversation on live chat</div>
								</div>

							</div>
						</div>
						<div nz-col nzSpan="12">
							<div  class="content-section addCursor pt-[13.63px] pr-[14px] pb-[15px] pl-[14px] rounded-[12px]">
								<a href="https://wa.me/+2349088430803" target="_blank">
								<svg fill="none" height="41" viewBox="0 0 40 41" width="40"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_17284_127177)">
										<circle cx="20" cy="20.6328" fill="#1EB12D" fill-opacity="0.1" r="20" />
										<path
											d="M20.0001 11.8359C15.8633 11.8359 12.5004 15.3364 12.5004 19.6356C12.5004 21.0676 12.8754 22.4622 13.5894 23.6789L12.5154 27.0265C12.4794 27.1389 12.5064 27.2605 12.5874 27.3448C12.6444 27.4041 12.7224 27.4353 12.8004 27.4353C12.8334 27.4353 12.8634 27.4321 12.8964 27.4197L16.1122 26.3059C17.2852 27.0453 18.6261 27.4353 20.0001 27.4353C24.1369 27.4353 27.4997 23.9379 27.4997 19.6356C27.4997 15.3364 24.1369 11.8359 20.0001 11.8359ZM24.7998 22.7929C24.7998 23.0643 24.6919 23.3326 24.5059 23.5261L23.7259 24.3279C23.5399 24.5213 23.2879 24.6274 23.0299 24.6274H22.9909C18.8001 24.4402 15.3803 20.8835 15.2003 16.5282C15.1883 16.2443 15.2933 15.9635 15.4883 15.7607L16.2592 14.9496C16.4452 14.7561 16.7032 14.6438 16.9672 14.6438H17.2552C17.6662 14.6438 18.0411 14.9121 18.1851 15.3146L18.8691 17.2021C19.0011 17.5702 18.9201 17.9914 18.6591 18.2785L18.3771 18.5873C18.2481 18.7277 18.2331 18.943 18.3381 19.1021C18.6861 19.6262 19.4301 20.6152 20.516 21.3765C20.666 21.4794 20.87 21.4607 21.002 21.3297L21.308 21.0302C21.581 20.7588 21.986 20.6745 22.34 20.8118L24.1549 21.5231C24.5419 21.676 24.7998 22.0629 24.7998 22.4903V22.7929Z"
											fill="#1EB12D" />
									</g>
									<defs>
										<clipPath id="clip0_17284_127177">
											<rect fill="white" height="40" transform="translate(0 0.632812)"
												width="40" />
										</clipPath>
									</defs>
								</svg>
								<div  class="bottom-content mt-[16px]">
									<div class="bottom-header font-[700] text-[18px] text-[#0B3275]">Whatsapp</div>
									<div class="bottom-label font-[600] text-[12px] leading-[15px] mt-[4px] opacity-50">Start a conversation on whatsapp</div>
								</div>
							</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="faq-section m-t-32">
				<div class="header-section flex-container gap-[10px] align-center">
					<div class="header font-[700] text-[19.2px] leading-[22px]">FAQs</div>
				</div>
		
				<div class="content m-t-16">
					<div class="content-section pt-[13.63px] pr-[14px] pb-[15px] pl-[14px] rounded-[12px]">
							<nz-collapse [nzAccordion]="true" [nzBordered]="false" [nzExpandIconPosition]="'right'">
								<nz-collapse-panel
								*ngFor="let ques of faqs"
								[nzHeader]="ques.question"
								#panel [nzActive]="false" [nzExtra]="extraTpl1"
								[nzShowArrow]="false">
								<div style="margin:0;" [innerHTML]="ques.answer">
								</div>
								<ng-template #extraTpl1>
									<a *ngIf="!panel.nzActive" class="ac-text text-primary">
										<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1363 4.99639C14.4878 5.34786 14.4878 5.91771 14.1363 6.26918L8.7363 11.6692C8.38483 12.0207 7.81498 12.0207 7.46351 11.6692L2.06351 6.26918C1.71204 5.91771 1.71204 5.34786 2.06351 4.99639C2.41498 4.64492 2.98483 4.64492 3.3363 4.99639L8.0999 9.76L12.8635 4.99639C13.215 4.64492 13.7848 4.64492 14.1363 4.99639Z" fill="#0361F0"/>
											</svg>
											
									</a>
									<a *ngIf="panel.nzActive" class="ac-text error text-primary">
										<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M1.8637 11.9692C1.51223 11.6177 1.51223 11.0479 1.8637 10.6964L7.2637 5.29639C7.61517 4.94492 8.18502 4.94492 8.53649 5.29639L13.9365 10.6964C14.288 11.0479 14.288 11.6177 13.9365 11.9692C13.585 12.3207 13.0152 12.3207 12.6637 11.9692L7.9001 7.20558L3.13649 11.9692C2.78502 12.3207 2.21517 12.3207 1.8637 11.9692Z" fill="#0361F0"/>
											</svg>									
									</a>
								</ng-template>
							  </nz-collapse-panel>
						
							</nz-collapse>
							<div class="view-all-btn pt-[20px] text-[14px] font-[500] text-[#0361F0]">
								<div class="flex items-center justify-center gap-[8px]" (click)="openSupport()">View All <span><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M5.21967 3.70246C5.51256 3.40956 5.98744 3.40956 6.28033 3.70246L10.7803 8.20246C11.0732 8.49535 11.0732 8.97022 10.7803 9.26312L6.28033 13.7631C5.98744 14.056 5.51256 14.056 5.21967 13.7631C4.92678 13.4702 4.92678 12.9954 5.21967 12.7025L9.18934 8.73279L5.21967 4.76312C4.92678 4.47022 4.92678 3.99535 5.21967 3.70246Z" fill="#0361F0"/>
									</svg>
									</span></div>
							</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div (click)="closeWidget()" class="floating-button flex-container align-center addCursor fixed py-[0x] px-[16px] gap-[4px] rounded-[50px] font-[500] text-[14px] leading-[130%] right-[22px] bottom-[26px] h-[56px] z-[99999999] text-white bg-[#0361F0]" *ngIf="showCloseButton">
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5.15152 5.65225C5.62015 5.18362 6.37995 5.18362 6.84858 5.65225L12 10.8037L17.1515 5.65225C17.6202 5.18362 18.3799 5.18362 18.8486 5.65225C19.3172 6.12088 19.3172 6.88068 18.8486 7.34931L13.6971 12.5008L18.8486 17.6523C19.3172 18.1209 19.3172 18.8807 18.8486 19.3493C18.3799 19.8179 17.6202 19.8179 17.1515 19.3493L12 14.1978L6.84858 19.3493C6.37995 19.8179 5.62015 19.8179 5.15152 19.3493C4.68289 18.8807 4.68289 18.1209 5.15152 17.6523L10.303 12.5008L5.15152 7.34931C4.68289 6.88068 4.68289 6.12088 5.15152 5.65225Z"
				fill="#fff"
			/>
		</svg>
	</div>
</div>
